import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1.4 12A5.6 5.6 0 0 1 7 6.4h10a5.6 5.6 0 1 1 0 11.2H7A5.6 5.6 0 0 1 1.4 12Zm9.064 4.4H17a4.4 4.4 0 1 0 0-8.8h-6.536A5.59 5.59 0 0 1 12.6 12a5.59 5.59 0 0 1-2.136 4.4ZM7 7.6a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8Z"
      clip-rule="evenodd"
    />
  </svg>
`;
